import React, { useEffect, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../Redux/Actions/SnackbarActions/SnackbarActions";
import PharmacySnackbar from "../../Utils/Snackbars/SnackbarUtil";
import {
  dateStringTimeConvert,
} from "../../Utils/titleCaseFunction";
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
  MuiPaper,
  MuiPagination
} from "../../Utils/Tables/CustomTable";
import { makeStyles } from "@material-ui/core/styles";
import { formatAmount } from "../../Utils/formatAmount";
import { LoadingGif } from "../../Utils/Loader";
import { history } from "../../Helpers/history";
import { ReusableRouteTabs } from "../../Utils/Tabs/ReusableTabs";
import axios from "axios";
import config from "../../Helpers/config.json";
import { errorMessages } from "../../Helpers/ErrorMessages";
import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import { useMuiPagination } from "../../Containers/Dasboard/DashboardTables";
import Form from "react-bootstrap/Form";
import FilterResults from 'react-filter-search';

const useStyles = makeStyles((theme) => ({
  icon: {
    width: "0.8em",
    height: "0.8em",
  },
  approved: {
    color: "green",
  },
  canceled: {
    color: "#D9512C",
  },
  pending: {
    color: "#F29339",
  },
}));

const DuplicateInvoices = ({ actions, snackbars }) => {
  const [loading, setLoading] = useState("idle");
  const [duplicates, setDuplicates] = useState([]);
  const [term, setTerm] = useState('')
  const {page, rowsPerPage, handleChangeRowsPerPage, handleChangePage} = useMuiPagination();


  useEffect(()=>{
    setLoading('loading');
    axios.get(`${config.epharmUrl}/Cpurchase/invoices/duplicates`).then(res => {
        const data = res.data;
        const dt = !data ? [] : data;
        setDuplicates(dt)
        setLoading("success");
    }).catch((err) => {
      errorMessages(err, null, actions);
        setLoading('error');
    })
  }, [])


  const handleSearch = (value) =>{
      setTerm(value)
  }

const handleCloseBar = () => {
  actions.snackbarActions.hideSnackBar();
};

const handleMergeNavigation = (duplicateData) => {
  // Navigate to merge page with invoice data
  const mergeParams = {
    originalInvoiceId: duplicateData.original_invoice_id,
    duplicateInvoiceId: duplicateData.duplicate_invoice_id,
    originalChalanNo: duplicateData.original_chalan_no,
    duplicateChalanNo: duplicateData.duplicate_chalan_no,
    purchaseDate: duplicateData.purchase_date,
    duplicatePurchaseId: duplicateData.duplicate_purchase_id,
    originalPurchaseId: duplicateData.original_purchase_id,
    grandTotalAmount: duplicateData.grand_total_amount
  };
  
  history.push(`/merge_invoices/${duplicateData.original_invoice_id}/${duplicateData.duplicate_invoice_id}`, {
    invoiceData: mergeParams
  });
};

  const { open, message, variant } = snackbars;

  const headData = [
    {
      id: "purchase_date",
      numeric: false,
      disablePadding: false,
      label: "Purchase Date",
    },
    {
      id: "original_invoice_no",
      numeric: false,
      disablePadding: false,
      label: "Original Invoice#",
    },
    {
      id: "duplicate_invoice_no",
      numeric: false,
      disablePadding: false,
      label: "Duplicate Invoice#",
    },
    {
      id: "tAmount",
      numeric: false,
      disablePadding: false,
      label: "Total Amount",
    },
    { id: "action", numeric: false, disablePadding: false, label: "Action" }
  ];
  const classes = useStyles();


  const components = [{label: 'All Purchases', path: '/managepurchase'},
        // {label: 'Canceled Purchases', path: '/canceled-purchases'},
        {label: 'Drafted Purchases', path: '/drafted_purchase'},
        {label: 'Duplicate Invoices', path: '/duplicate_invoices'}
    ]

    const isLoading = loading === "loading";
    const isSuccess = loading === "success";
    const isError = loading === "error";
  

  return (
    <div className="journals">
        <ReusableDashboardHeader
        heading="Purchases" 
        subHeading="Manage Duplicate Invoices" 
        component="Duplicate Invoices"
        link={history.location.pathname}
        />
      <PharmacySnackbar
        open={open}
        message={message}
        variant={variant}
        handleCloseBar={handleCloseBar}
      />
      <ReusableRouteTabs
        value={history.location.pathname}
        tabHeading={components}
      />
      <div className="mui-table">
        <MuiPaper>
          <EnhancedTableToolbar title="Purchases">
               <Form.Control 
                    data-testid="search_users"
                    type="text"
                      onChange={event => handleSearch(event.target.value)}
                      className='form__control'
                      placeholder="Search" style={{float: 'right'}}/>
          </EnhancedTableToolbar>
          <div>
            <Table
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <EnhancedTableHead headCells={headData} />
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={headData.length} align="center">
                      <LoadingGif />
                    </TableCell>
                  </TableRow>
                ) : null}
                {isSuccess ? (
                  <FilterResults
                    value={term}
                    data={duplicates}
                    renderResults={results => (
                      <>
                        {results.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((d, index) => {
                          return (
                            <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                            className="mui-table-row"
                          >
                            <TableCell>
                              {dateStringTimeConvert(d.purchase_date)}
                            </TableCell>
                            <TableCell>
                              <span data-testid={"original_invoice_no-" + index}>
                                {d.original_chalan_no}
                              </span>
                            </TableCell>
                            <TableCell>
                              <span data-testid={"duplicate_invoice_no-" + index}>
                                {d.duplicate_chalan_no}
                              </span>
                            </TableCell>
                            <TableCell>
                              <span data-testid={"grand_total_amount-" + index}>
                                {d.grand_total_amount
                                  ? formatAmount(d.grand_total_amount)
                                  : d.grand_total_amount}
                              </span>
                            </TableCell>
                            <TableCell id="mainbuttons">
                              <button
                                className="btn pharmacy-info-btn small-btn btn-sm px-3 mr-3"
                                onClick={() => handleMergeNavigation(d)}
                                data-testid={"merge-btn-" + index}
                              >
                                Merge
                              </button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </>
                    )}
                    />
                  ) : (
                    <TableRow>
                      <TableCell
                        data-testid="no_records_found"
                        colSpan={headData.length}
                        align="center"
                      >
                        No records found
                      </TableCell>
                    </TableRow>
                  )}
                {isError ? (
                  <TableRow>
                    <TableCell colSpan={headData.length} align="center">
                      The server did not return a valid response
                    </TableCell>
                  </TableRow>
                ) : null}
              </TableBody>
            </Table>
          </div>
          <MuiPagination data={duplicates} rowsPerPage={rowsPerPage} page={page}
                          handleChangeRowsPerPage={handleChangeRowsPerPage}
                          handleChangePage={handleChangePage} rows={[10, 20, 30, 50, 100]} colSpan={3}/>
        </MuiPaper>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    snackbars: state.snackbars,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateInvoices);
